import type { DancePlaybackGrant } from "@recital-master/shared";

type Listener = () => void;

const grants = new Map<string, DancePlaybackGrant>();
const listeners = new Set<Listener>();

function notify() {
  for (const listener of listeners) listener();
}

export function setCachedPlaybackGrants(next: DancePlaybackGrant[]) {
  for (const grant of next) grants.set(grant.danceId, grant);
  notify();
}

export function clearCachedPlaybackGrants() {
  grants.clear();
  notify();
}

export function getCachedPlaybackThumbUrl(danceId: string): string | null {
  const grant = grants.get(danceId);
  if (!grant) return null;
  return grant.playbackUrl.replace(/[^/]*$/, "thumb.jpg");
}

export function getCachedPlaybackStoryboardVttUrl(danceId: string): string | null {
  return grants.get(danceId)?.storyboardVttUrl ?? null;
}

export function subscribePlaybackGrantCache(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
